export default __webpack_public_path__ + "static/media/Group 89.0b304e2d.png";